import {
  fireViewItemListGAEvent,
  fireEventPromotionBanner,
  fireListCategoryPushEvent,
} from '@global/gtm/base';

class ShopListView {
  constructor() {
    const hasCategory = window.ItemCategories || undefined;

    this.category = {
      itemCategory: hasCategory && hasCategory[0] ? hasCategory[0] : '',
      itemCategory2: hasCategory && hasCategory[1] ? hasCategory[1] : '',
      itemCategory3: hasCategory && hasCategory[2] ? hasCategory[2] : '',
      itemCategory4: hasCategory && hasCategory[3] ? hasCategory[3] : '',
      itemCategory5: hasCategory && hasCategory[4] ? hasCategory[4] : '',
      url: window.location.href,
    };
  }

  getItemListName() {
    let combineCategory = '';

    for (const key in this.category) {
      if (key !== 'url' && this.category[key]) {
        if (combineCategory === '') {
          combineCategory = this.category[key];
        } else {
          combineCategory = `${combineCategory}--${this.category[key]}`;
        }
      }
    }

    const searchParams = new URLSearchParams(decodeURI(window.location.search));
    const page = searchParams.get('Page');

    combineCategory = page
      ? `${combineCategory} 產品列表 Page ${page}`
      : `${combineCategory} 產品列表`;

    return combineCategory;
  }

  getListInfo() {
    const allListItem = window.dataLayer.find((obj) => obj.ecommerce && obj.ecommerce.impressions);

    const items = [];

    if (allListItem) {
      allListItem.ecommerce.impressions.forEach((item, index) => {
        const impression = {
          item_id: item.id,
          item_name: item.name,
          index,
          item_list_name: item.list,
          item_brand: '',
          item_category: this.category.itemCategory,
          item_category2: this.category.itemCategory2,
          item_category3: this.category.itemCategory3,
          item_category4: this.category.itemCategory4,
          item_category5: this.category.itemCategory5,
          price: parseInt(item.price),
          quantity: 1,
          affiliation: item.variant,
        };
        items.push(impression);
      });
    }

    return items;
  }

  getRecommendListInfo(listName) {
    const allListItem = window.dataLayer.find((obj) => obj.ecommerce && obj.ecommerce.impressions);

    const items = [];

    if (allListItem) {
      allListItem.ecommerce.impressions.forEach((item, index) => {
        const impression = {
          item_id: item.id,
          item_name: item.name,
          index,
          item_list_name: listName,
          item_brand: '',
          item_category: this.category.itemCategory,
          item_category2: this.category.itemCategory2,
          item_category3: this.category.itemCategory3,
          item_category4: this.category.itemCategory4,
          item_category5: this.category.itemCategory5,
          price: parseInt(item.price),
          quantity: 1,
          affiliation: item.variant,
        };
        items.push(impression);
      });
    }

    return items;
  }

  getSearchRecommendListInfo(listName, recommendData) {
    const recommendItems = recommendData.map((data, index) => {
      return {
        item_id: data.Colors[0].CustomMarketID.split('SZ')[0],
        item_name: data.Name,
        index,
        item_list_name: listName,
        item_brand: '',
        item_category: this.category.itemCategory,
        item_category2: this.category.itemCategory2,
        item_category3: this.category.itemCategory3,
        item_category4: this.category.itemCategory4,
        item_category5: this.category.itemCategory5,
        price: parseInt(data.SellPrice),
        quantity: 1,
        affiliation: data.Colors[0].ColorName,
      };
    });

    return recommendItems;
  }

  static getSearchListInfo(payload, listName) {
    const allListItem = window.dataLayer.find((obj) => obj.ecommerce && obj.ecommerce.impressions);

    const items = [];

    if (allListItem) {
      allListItem.ecommerce.impressions.forEach((item, index) => {
        const impression = {
          item_id: item.id,
          item_name: item.name,
          index,
          item_list_name: listName,
          item_brand: '',
          item_category: payload.isHotSearch ? '關鍵字熱搜' : '關鍵字搜尋',
          item_category2: payload.keyword,
          price: parseInt(item.price),
          quantity: 1,
          affiliation: item.variant,
        };
        items.push(impression);
      });
    }

    return items;
  }

  static getPromotionInfo() {
    const promotionFromStorage = JSON.parse(localStorage.getItem('promotion'));

    return promotionFromStorage || null;
  }

  static checkIsHotSearch(hotList) {
    if (hotList.length === 0) return { isHotSearch: false, keyword: '' };

    const params = new URL(window.location.href).searchParams;
    const keyword = params.get('keyword') || params.get('Keyword') || '';
    const isHotSearch = hotList.includes(keyword);

    return { isHotSearch, keyword };
  }
}

export default function fireShopListViewEvent() {
  window.dataLayer = window.dataLayer || [];

  const shopListView = new ShopListView();

  fireListCategoryPushEvent(shopListView.category);

  fireViewItemListGAEvent({
    itemListName: shopListView.getItemListName(),
    items: shopListView.getListInfo(),
  });
}

export function firePromotionEvent() {
  window.dataLayer = window.dataLayer || [];

  const shopListView = new ShopListView();

  const listItems = shopListView.getListInfo();
  const promotion = ShopListView.getPromotionInfo();

  if (promotion) {
    fireEventPromotionBanner({
      promotionTargetUrl: `促銷活動--${window.PictureContainer}`,
      promotionItems: listItems,
      promotionCreativeName: promotion.imgLink,
      promotionCreativeSlot: promotion.clickName,
    });
  }
}

/**
 * URLiving 搜尋結果頁所使用的 GA 事件
 *
 * @param {Array} hotSearchList - 關鍵字列表
 */
export function fireShopListSearchEvent(hotSearchList) {
  window.dataLayer = window.dataLayer || [];

  const shopListView = new ShopListView();
  const isHotSearch = ShopListView.checkIsHotSearch(hotSearchList);

  let itemListName = '';

  if (window.TotalCount === 0) {
    itemListName = isHotSearch.isHotSearch
      ? `關鍵字熱字--${isHotSearch.keyword}推薦產品列表`
      : `關鍵字搜尋--${isHotSearch.keyword}推薦產品列表`;

    fireViewItemListGAEvent({
      itemListName,
      items: shopListView.getRecommendListInfo(itemListName),
    });
  } else {
    itemListName = isHotSearch.isHotSearch
      ? `關鍵字熱字--${isHotSearch.keyword}產品列表`
      : `關鍵字搜尋--${isHotSearch.keyword}產品列表`;

    fireViewItemListGAEvent({
      itemListName,
      items: ShopListView.getSearchListInfo(isHotSearch, itemListName),
    });
  }
}

/**
 * 其他客製品牌搜尋結果頁所使用的 GA 事件 for 商品列表
 *
 * @param {Array} hotSearchList - 關鍵字列表
 */
export function fireSearchListEvent(hotSearchList) {
  window.dataLayer = window.dataLayer || [];

  const isHotSearch = ShopListView.checkIsHotSearch(hotSearchList);

  if (window.TotalCount !== 0) {
    const itemListName = isHotSearch.isHotSearch
      ? `關鍵字熱字--${isHotSearch.keyword}產品列表`
      : `關鍵字搜尋--${isHotSearch.keyword}產品列表`;

    fireViewItemListGAEvent({
      itemListName,
      items: ShopListView.getSearchListInfo(isHotSearch, itemListName),
    });
  }
}

/**
 * 其他客製品牌搜尋結果頁所使用的 GA 事件 for 推薦列表
 *
 * @param {Array} hotSearchList - 關鍵字列表
 */
export function fireSearchResultRecommendEvent(hotSearchList, recommendData) {
  window.dataLayer = window.dataLayer || [];

  const shopListView = new ShopListView();
  const isHotSearch = ShopListView.checkIsHotSearch(hotSearchList);

  const itemListName = isHotSearch.isHotSearch
    ? `關鍵字熱字--${isHotSearch.keyword}推薦產品列表`
    : `關鍵字搜尋--${isHotSearch.keyword}推薦產品列表`;

  fireViewItemListGAEvent({
    itemListName,
    items: shopListView.getSearchRecommendListInfo(itemListName, recommendData),
  });
}
